import React, { useRef } from 'react';
import { useState } from 'react';
import emailjs from '@emailjs/browser';

import './Contact.css'

function Contact(){
    const [isMessageSent, setMessageSent] = useState(false);

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();


        emailjs.sendForm('KarinVRealtor', 'RealtorSite', form.current, 'uXWS0TjheyCb0F7VC')
      .then((result) => {
          console.log(result.text);
          e.target.reset(); //reset input fields
          setMessageSent(true); //show popup when message is sent

          setTimeout(() => {
            setMessageSent(false);
          }, 3000);

      }, (error) => {
          console.log(error.text);
      });
    };


    return(
        <div className='Contact'>

           <div className="contactContainer">
            <h2 id="contactTitle"> Contact Me Today.</h2>
               <div className="contactCard ">
                    <form ref={form} onSubmit={sendEmail}>
                        <input type="text" id="user_name" name="user_name" placeholder="Enter Name" />
                        <br/>
                        <input type="email" id="user_email" name="user_email" placeholder="Enter Email"  />
                        <br/>
                        <input type="number" id="phone_number" name="phone_number" placeholder='Enter Phone Number' maxLength="12"  />
                        <br/>
                        <textarea id="text-area" name="message" rows="4" placeholder="Enter Message Here" ></textarea>
                        <br/>
                        <input type="submit" id="submit" value="Send" />
                    </form> 
                    
                        <div className={`popup ${isMessageSent ? 'show' : 'hide'}`}>
                            <p>Message Sent!</p>
                        </div>
                   
                </div>
            </div>
            
        </div>
    );
}

export default Contact;